export const colors = {
  buttons: {
    primary: '#91470D',
    primaryHover: '#5A3006',
    secondary: '#C47E13',
    secondaryHover: '#CF8F2C',
    dark: '#402C18',
    darkHover: '#301800',
    light: '#CDA768',
    text: '#FFF5E3',
  },
  text: {
    dark: '#402C18',
    accent: '#87501A',
    light: '#FFF5E3',
    active: '#C47E13',
  },
  background: {
    light: '#EAD1A3',
    dark: '#402C18',
    accent: '#CDA768',
    medium: '#C69D59',
    transparent: '#D4A24E7A',
    tooltip: '#FAEBD1',
  },
  elements: {
    primary: '#E6B25D',
    primaryHover: '#E7BC75',
    dark: '#402C18',
    skeletonPrimary: '#B27D28',
    skeletonSecondary: '#F4C06C',
    accent: '#87501A',
  },
  border: {
    primary: '#402C18',
  },
  gradient: {
    fade: 'linear-gradient(90deg, #402C18 40.38%, rgba(166, 114, 62, 0) 100%)',
  },
  accent: {
    success: '#387545',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
};
